import React, {useState, useEffect, useMemo, useRef} from 'react';
import { ScrollView, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import Modal from '../../../../../components/Modal';
import Header from '../../../../../navigation/Header';
import { useForm } from 'react-hook-form';
import Input from '../../../../../components/Forms/Input';
import IconButton from '../../../../../components/IconButton';
import api from '../../../../../utils/api';
import { useQuery } from '@tanstack/react-query';


import { useToast } from 'react-native-toast-notifications';
import UnitFeeLevelSelector from '../Components/UnitFeeLevelSelector';



function FeeLevelsSettings({ levels, communityId, onLevelsSaved }){
  const { control, reset, formState: {isDirty, dirtyFields}, handleSubmit } = useForm();
  const [showNewLevel, setShowNewLevel] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const toast = useToast()

  useEffect(() => {
    const _levels = levels?.map(level => {
      return {
        ...level,
        amount: `${level.amount}`
      }
    })

    reset({levels: _levels})
  }, [levels]);


  function renderRow(index){
    return (
      <View key={index} style={tw`row gap-x-3`}>
        <Input
          control={control}
          name={`levels[${index}].name`}
          rules={{required: true}}
          style={{ container: tw`flex-1 mb-2`, subcontainer: `bg-transparent border border-gray-200`, input: `py-2` }}
        />

        <View style={tw`row`}>
          <Input
            control={control}
            name={`levels[${index}].amount`}
            rules={{required: true}}
            placeholder=''
            style={{ container: tw`mb-2`, input: `w-28 pl-10 py-2` }} 
            keyboardType="numeric" 
          />
          <Text style={tw`absolute left-6 text-gray-500 top-3 `}>$</Text>
        </View>

        <View style={tw`w-10`}>

        </View>
      </View>
    )
  }

  function submitForm(data){
    const changedLevels = []
    
    dirtyFields.levels.forEach((field, index) => {
      if(!! field) changedLevels.push(data.levels[index])
    })


    setSubmitting(true)

    console.log({levels: changedLevels});
    
    
    api.post(`/communities/${communityId}/fees/types`, { types: changedLevels })
    .then((response) => {
      toast.show("Tipos de cuota guardados", {type: "success"})
      setSubmitting(false)
      onLevelsSaved?.()
    })
    .catch((error) => {
      console.error(error);
      setSubmitting(false)
    })
  }


  return (
    <View style={tw`px-3`}>
      {
        levels?.map((level, i) =>
          renderRow(i)
        )
      }

      {
        showNewLevel &&
          renderRow(levels ? levels.length : 0)
      }

      {
        ! isDirty ?
          <IconButton
            onPress={() => setShowNewLevel(true)}
            title={"Agregar variación de costo"}
            style={tw`bg-white border border-primary mt-2 border-dashed border-[0.45]`}
            textColor={'primary'}
          />
        :
          <IconButton
            onPress={handleSubmit(submitForm)}
            disabled={submitting}
            title={ submitting ? "Guardando" : "Guardar"}
            style={tw`bg-white border border-secondary mt-2 border-[0.45]`}
            textColor={'secondary'}
          />
      }
    </View>
  )
}





function UnitRow({ onPress, index, item, rightComponent }){
  return (
    <TouchableOpacity
      style={tw.style(`row justify-between px-4 h-15`, index % 2 == 1 && `bg-gray-100`)}
      disabled={!onPress}
      onPress={onPress}
    >
      <View style={tw`flex-1`}>
        <Text style={tw`text-secondary`}>{item.name}</Text>

        {
          item.owners?.length > 0 &&
            <Text style={tw`text-gray-400`}>{item.owners[0].name}</Text>
        }
      </View>

      <View style={tw` items-end`}>
        {rightComponent}
      </View>
    </TouchableOpacity>
  )
}


function MainFeeInput({ feeTypes, communityId, onLevelSaved }){
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const inputRef = useRef<any>()
  const toast = useToast()


  const mainFeeType = useMemo(() => {
    return feeTypes?.find(feeType => feeType.type === "main" && ! feeType.is_variant)
  }, [feeTypes])

  useEffect(() => {
    setValue(mainFeeType?.amount)
  }, [mainFeeType?.amount]);


  function submitChange() {
    const changedTypes = feeTypes.map((feeType, index) => {
      const _feeType = {...feeType}
      if (feeType.type == "main"){
        _feeType.amount = value
      }
      return _feeType
    })


    setSubmitting(true)

    api.post(`/communities/${communityId}/fees/types`, { types: changedTypes })
      .then((response) => {
        toast.show("Costo de cuota actualizado", { type: "success" })
        setSubmitting(false)
        onLevelSaved?.()
      })
      .catch((error) => {
        console.error(error);
        setSubmitting(false)
      })
  }


  return (
    <View style={tw`row justify-center border-b border-white/20 py-3 mb-3`}>
      <View style={tw.style(`row items-center rounded py-1`, editing && `bg-white/10`)}>
        <Text style={tw`text-center h-8 text-white text-4xl text-red font-500 mr-1 pl-2`}>$</Text>

        <TextInput
          value={`${value ?? ''}`}
          style={tw`text-left text-4xl text-white w-24 h-10 font-500 pt-0`}
          keyboardType='numeric'
          ref={inputRef}
          onChangeText={setValue}
          editable={editing}
        />
      </View>

      <TouchableOpacity
        style={tw`absolute right-2`}
        disabled={submitting}
        onPress={() => {
          if(!editing){
            setEditing(true)
            inputRef.current?.focus()
          }else{
            setEditing(false)
            inputRef.current?.blur()
            submitChange()
          }
        }}
      >
        {
          submitting ?
            <Text style={tw`text-primary/50`}>{"Guardando..."}</Text>
          :
            <Text style={tw`text-primary`}>{editing ? "Guardar" : "Editar"}</Text>
        }
      </TouchableOpacity>
    </View>
  )
}

export default function MainteinancesFeesSettingsScreen({navigation, route}) {
  const { communityId } = route.params

  const { isLoading, error, data: units, refetch: refetchUnits } = useQuery({
    queryKey: ['community.units', communityId],
    queryFn: () => api.get(`/communities/${communityId}/units?with=fee_type`).then(response => response.data),
  })
  

  const { isLoading: loadingLevels, data: feeTypes, refetch: refetchLevels } = useQuery({
    queryKey: ['community.fees.levels', communityId],
    queryFn: () => api.get(`/communities/${communityId}/fees/types`).then(response => response.data),
  })
  
  const mainteinanceFeeTypes = useMemo(() => {
    return feeTypes?.filter(feeType => feeType.type === "main")
  }, [feeTypes])

  const variantsFeeTypes = useMemo(() => {
    return feeTypes?.filter(feeType => feeType.type === "main" && feeType.is_variant)
  }, [feeTypes])



  return (
    <>
      <Header style={`mb-0 bg-secondary`} showBackButton backButtonColor='white'>
        <View style={tw`flex-1`}>
          <View style={tw`row`}>
            {/* <Image source={require('../../../../assets/images/icons/calendario.svg')} style={tw`h-6 w-6`} /> */}

            <Text style={tw`ml-3 text-xl font-600 text-white`}>Cuota principal</Text>
          </View>

          <MainFeeInput
            communityId={communityId}
            feeTypes={feeTypes}
            onLevelSaved={() => {
              refetchLevels()
              refetchUnits()
            }}
          />
          
          <Text style={tw`text-center text-white`}>Cada día primero de mes los residentes recibirán un recordatorio de pago</Text>
        </View>
      </Header>

      <ScrollView style={tw`bg-white flex-1`}>

        {/* Variación de costo */}
        <View style={tw`mb-4`}>
          <View style={tw`bg-gray-100 px-4 py-2 mb-3`}>
            <Text style={tw`text-gray-400`}>Variación de costo</Text>
          </View>

          <FeeLevelsSettings
            levels={variantsFeeTypes}
            communityId={communityId}
            onLevelsSaved={() => {
              refetchLevels()
              refetchUnits()
            }}
          />
        </View>


        {/* Viviendas */}
        <View>
          <View style={tw`bg-gray-100 px-4 py-2 row justify-between mb-3`}>
            <Text style={tw`text-gray-400`}>Vivienda</Text>
            <Text style={tw`text-gray-400`}>Monto / Variante</Text>
          </View>

          <View>
            {
              units?.map((item, i) =>
                <UnitRow
                  key={item.uuid}
                  index={i}
                  item={item}
                  rightComponent={
                    <UnitFeeLevelSelector
                      unit={item}
                      feeTypes={mainteinanceFeeTypes}
                      communityId={communityId}
                      onFeeLevelUpdated={() => {
                        refetchUnits()
                      }}
                    />
                  }
                />
              )
            }

            {
              isLoading &&
                <Text style={tw`mt-10 text-gray-300 text-center`}>Cargando...</Text>
            }
          </View>
        </View>
      </ScrollView>
    </>
  );
}
